import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, loadTrackers } from "@/lib/consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (consent === null) setVisible(true);
    else if (consent === "granted") loadTrackers();

    const reopen = () => setVisible(true);
    window.addEventListener("open-cookie-consent", reopen);
    return () => window.removeEventListener("open-cookie-consent", reopen);
  }, []);

  const choose = (v) => {
    setConsent(v);
    setVisible(false);
    if (v === "granted") loadTrackers();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="fixed bottom-0 inset-x-0 z-[80] p-4 sm:p-6"
        >
          <div className="max-w-4xl mx-auto glass rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 shadow-2xl">
            <Cookie className="w-6 h-6 text-sky-600 shrink-0" />
            <p className="text-xs sm:text-sm text-slate-600 leading-relaxed flex-1">
              Nous utilisons des témoins d'analyse et de marketing (Google Analytics, Meta Pixel)
              pour mesurer l'achalandage et améliorer votre expérience. Conformément à la Loi 25,
              ces témoins ne sont activés qu'avec votre consentement. Votre choix est conservé
              12 mois et vous pouvez le modifier en tout temps via « Préférences de témoins »
              au bas de la page.{" "}
              <a data-testid="cookie-privacy-link" href="/confidentialite" className="text-sky-600 underline underline-offset-2 hover:text-sky-600">
                Consultez notre politique de confidentialité
              </a>
              .
            </p>
            <div className="flex gap-3 shrink-0 w-full sm:w-auto">
              <button
                data-testid="cookie-refuse-button"
                onClick={() => choose("denied")}
                className="flex-1 sm:flex-none rounded-full border border-slate-900/20 px-5 py-2.5 text-sm font-semibold text-slate-600 hover:border-slate-900/100 transition-colors duration-300"
              >
                Refuser
              </button>
              <button
                data-testid="cookie-accept-button"
                onClick={() => choose("granted")}
                className="flex-1 sm:flex-none rounded-full bg-sky-400 px-5 py-2.5 text-sm font-bold text-[#0A1220] hover:bg-sky-300 transition-colors duration-300"
              >
                Accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
